export const permissionsEnergy = [
  "energy",
  "everything-full",
  "everything-readonly",
];
